// ============================================================================
// FEEDBACK
// Types for gathering feedback from users.
// ============================================================================

export enum FeedbackType { 
  BUG = "bug",
  SUGGESTION = "suggestion",
  COMPLIMENT = "compliment",
  OTHER = "other"
}

export interface FeedbackDocument {
  type: FeedbackType;
  content: string;
}

export const FeedbackConstraints = {
  document: {
    content: {
      maxLength: 1000
    }
  }
} as const;